module.exports = __webpack_public_path__ + "static/media/Tríceps.29098114.png";